import { render, staticRenderFns } from "./CreateSubOffice.vue?vue&type=template&id=2f39b200&scoped=true"
import script from "./CreateSubOffice.vue?vue&type=script&lang=js"
export * from "./CreateSubOffice.vue?vue&type=script&lang=js"
import style0 from "./CreateSubOffice.vue?vue&type=style&index=0&id=2f39b200&prod&scoped=true&lang=css"
import style1 from "./CreateSubOffice.vue?vue&type=style&index=1&id=2f39b200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39b200",
  null
  
)

export default component.exports